export default __webpack_public_path__ + "static/media/exchvnge-logo-white.25f77adf.png";